import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { MenuItem } from 'primeng/api';
import { ScheduleModeEnum } from 'src/app/communication/shared/schedule-mode.enum';
import { MessageResendDto } from 'src/app/communication/shared/message-resend.dto';
import { MessageResendRecipientsEnum } from 'src/app/communication/shared/message-resend-recipients-enum';

import { MassCommService } from 'src/app/communication/shared/mass-comm.service';
import { TranslationService } from 'src/app/shared/translation/translation.service';
import { NotificationService } from 'src/app/shared/notification/notification.service';

@Component({
  selector: 'wl-mass-comm-message-edit-analytics-resend-dialog',
  templateUrl: './mass-comm-message-edit-analytics-resend-dialog.component.html',
    standalone: false
})
export class MassCommMessageEditAnalyticsResendDialogComponent {
  showDialog: boolean = false;
  isSaving: boolean = false;
  sendButtonText: string = '';
  originalMessageId: number = 0;
  menuItemResendToOptionSelected: MenuItem = null;
  scheduleModes: Array<{ mode: ScheduleModeEnum; sendButtonText: string }>;
  selectedScheduleMode: ScheduleModeEnum;
  sendLaterDate: Date = new Date();

  constructor(
    private _translationService: TranslationService,
    private _massCommService: MassCommService,
    private _notificationService: NotificationService,
    private _router: Router
  ) {
    this.scheduleModes = [
      {
        mode: ScheduleModeEnum.Immediate,
        sendButtonText: this._translationService.getInstantTitlecase(
          'communications.mass-comm-message-edit.analytics.resend.dialog.button-send-now'
        ),
      },
      {
        mode: ScheduleModeEnum.DelaySend,
        sendButtonText: this._translationService.getInstantTitlecase(
          'communications.mass-comm-message-edit.analytics.resend.dialog.button-send-later'
        ),
      },
    ];

    this.sendLaterDate.setDate(this.sendLaterDate.getDate() + 1);
  }

  open(originalMessageId: number, menuItemResendToOptionSelected: MenuItem) {
    this.originalMessageId = originalMessageId;
    this.menuItemResendToOptionSelected = menuItemResendToOptionSelected;
    this.showDialog = true;
  }

  close() {
    this.selectedScheduleMode = null;
    this.sendButtonText = '';
    this.sendLaterDate = new Date();
    this.menuItemResendToOptionSelected = null;
    this.showDialog = false;
    this.isSaving = false;
  }

  setSendButtonText() {
    this.sendButtonText = this.scheduleModes.find((scheduleMode) => scheduleMode.mode === this.selectedScheduleMode).sendButtonText;
  }

  send() {
    this.isSaving = true;

    let message = {} as MessageResendDto;
    message.OriginalMessageId = this.originalMessageId;
    message.MessageResendRecipients =
      this.menuItemResendToOptionSelected.id === 'all' ? MessageResendRecipientsEnum.All : MessageResendRecipientsEnum.UnopenedOnly;
    message.ScheduleMode = this.selectedScheduleMode;
    message.SendLaterDate = this.sendLaterDate;

    this._massCommService
      .resendMessage(message)
      .then((messageIdCreated: number) => {

        if (message.ScheduleMode === ScheduleModeEnum.Immediate) {
          this._notificationService.translateSuccess('communications.mass-comm-message-edit.analytics.resend.dialog.success-resend-now');
        }
        else {
          this._router.navigate(['communications/message/resend', messageIdCreated]);
        }
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      })
      .finally(() => {
        this.close();
      });
  }
}
